import { Avatar, Card, Typography } from "antd";
import { motion } from "framer-motion";
import { Outlet } from "react-router-dom";

import { AccountNavMenu } from "@/components/Account";
import { useAuth, useResponsive } from "@/hooks";
import { confirmLogout } from "@/utils/auth-confirm";

const { Text, Title } = Typography;

export const AccountLayout = () => {
  const { isDesktop } = useResponsive();
  const { logout, user } = useAuth();
  const handleLogout = () => {
    confirmLogout(() => logout());
  };

  return (
    <div className="account-layout">
      <aside className="account-layout__sidebar">
        <div className="account-layout__sidebar-sticky">
          <Card className="account-layout__summary">
            <Avatar size={80} src={user?.avatar}>
              {user?.name?.slice(0, 1)?.toUpperCase() || "K"}
            </Avatar>
            <Title level={4}>{user?.name || "Khách hàng ERP Gold"}</Title>
            <Text type="secondary">{user?.email || user?.phone || "--"}</Text>
          </Card>

          <Card className="account-layout__nav-card">
            <AccountNavMenu onLogout={handleLogout} />
          </Card>
        </div>
      </aside>

      <motion.div
        animate={{ opacity: 1, y: 0 }}
        className="account-layout__content"
        initial={{ opacity: 0, y: 12 }}
        transition={{ duration: 0.24 }}
      >
        {!isDesktop ? (
          <>
            <Card className="account-layout__summary account-layout__summary--mobile">
              <Avatar size={64} src={user?.avatar}>
                {user?.name?.slice(0, 1)?.toUpperCase() || "K"}
              </Avatar>
              <div>
                <Title level={4}>{user?.name || "Khách hàng ERP Gold"}</Title>
                <Text type="secondary">
                  {user?.email || user?.phone || "--"}
                </Text>
              </div>
            </Card>

            <AccountNavMenu mobile onLogout={handleLogout} />
          </>
        ) : null}

        <Outlet />
      </motion.div>
    </div>
  );
};
